// @flow

import * as React from 'react';

import s from './Spinner.scss';

type Props = {
  left: string,
  top: string,
  fontSize: string,
  visible: boolean,
}

export const Spinner = (props: Props) => {
  const { left, top, fontSize, visible } = props;
  const style = {
    left,
    top,
    display: visible ? 'block' : 'none',
  }

  return (
    <div className={s.spinner} style={style}>
      <svg viewBox="25 25 50 50" width={fontSize}>
        <circle cx="50" cy="50" r="20"></circle>
      </svg>
    </div>
  )
}



export default Spinner;
